import React, { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { TrendingUp, Users, CalendarClock, Map, Shield, Radio } from "lucide-react";

const ICON = { trending: TrendingUp, users: Users, calendar: CalendarClock, map: Map, shield: Shield };

export default function SignalsTicker() {
  const [signals, setSignals] = useState([]);
  const paused = useRef(false);

  useEffect(() => {
    const load = async () => {
      try { const { data } = await api.get("/signals"); setSignals(data.signals || []); } catch {}
    };
    load();
    const id = setInterval(load, 60_000); // refresh every 60s
    return () => clearInterval(id);
  }, []);

  if (signals.length === 0) return null;

  // Duplicate to make seamless scroll
  const loop = [...signals, ...signals];

  return (
    <div
      data-testid="signals-ticker"
      className="glass rounded-full overflow-hidden flex items-center gap-3 h-10 pl-4 pr-2"
      onMouseEnter={() => (paused.current = true)}
      onMouseLeave={() => (paused.current = false)}
    >
      <div className="flex items-center gap-2 text-[#10B981] text-xs uppercase tracking-[0.2em] shrink-0">
        <Radio className="h-3.5 w-3.5 acre-pulse" />
        <span className="hidden sm:inline">Live</span>
      </div>
      <div className="relative flex-1 overflow-hidden h-full">
        <div
          className={`absolute top-0 left-0 flex items-center gap-8 h-full whitespace-nowrap animate-ticker ${paused.current ? "[animation-play-state:paused]" : ""}`}
          style={{ animationDuration: `${Math.max(30, signals.length * 6)}s` }}
        >
          {loop.map((s, i) => {
            const Ic = ICON[s.icon] || TrendingUp;
            return (
              <div key={i} className="flex items-center gap-2 text-xs md:text-sm text-slate-200">
                <Ic className="h-3.5 w-3.5 text-[#10B981]" />
                <span>{s.text}</span>
                <span className="h-1 w-1 rounded-full bg-[#334155]" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
